import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { recoverPassword, resetPassword } from '../store/passwordRecovery/actions'

import ForgoteMyPasswordForm from '../components/form/ForgoteMyPasswordForm'
import ResetPasswordForm from '../components/form/ResetPasswordForm'
import AppLink from '../components/shared/AppLink'

import {
  container,
  linkContainer
} from './styles/LoginPage.style'

const ForgotMyPasswordPage = ({
  recoverPassword,
  userPhrase,
  resetPassword,
  match: { params: { token } },
  lang
}) => {
  const { t } = useTranslation()
  return (
    <div className={container}>
      {!userPhrase && !token && (<ForgoteMyPasswordForm lang={lang} translation={t} onSubmit={(data) => recoverPassword({ data, translation: t })} />)}
      {(userPhrase || token) && (<ResetPasswordForm lang={lang} translation={t} onSubmit={(data) => resetPassword({ data, translation: t })} token={token} />)}

      <div className={linkContainer}>
        <AppLink to={'/'}>{t('resetPassword')['backLink']}</AppLink>
      </div>
    </div>
  )
}

ForgotMyPasswordPage.propTypes = {
  recoverPassword: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  userPhrase: PropTypes.object,
  match: PropTypes.object,
  lang: PropTypes.string
}

ForgotMyPasswordPage.defaultProps = {
  loginValues: undefined
}

const mapStateToProps = ({ passwordRecovery, auth }) => ({
  userPhrase: passwordRecovery.userPhrase,
  lang: auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      recoverPassword,
      resetPassword
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(ForgotMyPasswordPage)
